
export default {
  props: ["element"],
  name: "hyperCoreImage",
  computed: {
    width(){
      return this.$store.getters.isMobile?this.element.widthMobile:this.element.width;
    },
    height(){
      return this.$store.getters.isMobile?this.element.heightMobile:this.element.height;
    },
    actualSource() {
      let src = this.element.sources
        ? (this.element.sources.find((ss) => !ss.media) || []).src
        : this.$store.getters.isMobile && this.element.srcMobile
        ? this.element.srcMobile
        : this.element.src;
        try{  
          let width = this.$store.getters.isMobile?this.element.widthMobile:this.element.width;
          src = $nuxt.$hyperUtility.imgproxy(src, width);
        }catch(error){
        }
      try {
        if (src && src.includes("eshopIcon")) {
          let eshopIcon = $nuxt.$hyperUtility;
          let $hyperUtility = $nuxt.$hyperUtility;
          return eval(src);
        }
      } catch (error) {}

      return src;
    },
  },
};
